export default __webpack_public_path__ + "static/media/orange-juice-menu@2x.8379ee4c.png";